import React,{ useState, useContext, useEffect} from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
  Image,
} from "react-native";

import { Text, Rating } from "react-native-elements";
import AppButton from "../Buttons/AppButton";

import { urlImage } from "../../utils/AppConst";
import { Context as UserContext } from "../../dataStore/userAccessContext";

const deviceWidth = Math.round(Dimensions.get("window").width);

const GrupoCard = ({ size, data, onSelect, disable = false }) => {
  const { descripcion, sucursalid, foto, direccion, foodType, grupoid } = data.item;

  const { returnFotoGrupo } = useContext(
    UserContext
  );
  const [fotoUrl, setFotoUrl] = useState(null);

    // useEffect para llamar a obtenerFoto cuando el componente se monte
  useEffect(() => {
    obtenerFoto(grupoid);
  }, [grupoid]); // Se ejecuta cuando el idproducto cambia

  //console.log(data);

  function obtenerFoto(id) {
    // Declaras la función como async
    return (async () => {
      var foto = await returnFotoGrupo(id);
      return mostrarFoto(foto);
    })();
  }


  function mostrarFoto(img1) {
    //let input = document.frmConvert.hex.value.replace(/[^A-Fa-f0-9]/g, "");
    var imagen = foto;
    if(img1){
      imagen = img1;
    }
    if (imagen % 2) {
        console.log("cleaned hex string length is odd.");
        return;
    }

    let binary = new Array();
    for (let i = 0; i < imagen.length / 2; i++) {
        let h = imagen.substr(i * 2, 2);
        binary[i] = parseInt(h, 16);
    }

    let byteArray = new Uint8Array(binary);
    let img = document.querySelector('.heximage');

    setFotoUrl(window.URL.createObjectURL(new Blob([byteArray], { type: 'application/octet-stream' })));
    return fotoUrl;
    //document.body.appendChild(img)
}


  const mediumCard = () => {
    return (
      <View style={styles.root}>
        <TouchableOpacity onPress={() => onSelect({...data,['foto']:fotoUrl})}>
          <Image style={styles.foodImage} source={{ uri: fotoUrl ?? "" }} />
          <Text style={smallStyles.title}>{descripcion}</Text>
        </TouchableOpacity>
      </View>
    );
  };

  const smallCard = () => {
    return (
      <TouchableOpacity
        style={smallStyles.smallCard}
        onPress={() => onSelect({...data.item,['foto']:fotoUrl})}
        disabled={disable}
      >
        <Image style={smallStyles.foodImageSmall} source={{ uri: fotoUrl ?? "" }} />
        <View style={smallStyles.productInfo}>
          <Text style={smallStyles.title}>{String(descripcion).toUpperCase()}</Text>
        </View>
      </TouchableOpacity>
    );
  };

  switch (size) {
    case "small": // wide card
      return smallCard();
    case "medium": // medium card
      return smallCard();
    default:
      return smallCard();
  }
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    margin: 10,
  },
  foodImage: {
    borderRadius: 20,
    height: 220,
    width: deviceWidth - 30,
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
  },
  title: {
    fontSize: 13,
    fontWeight: "460",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    marginTop: 10,
    color: "#636363",
  },
});

const smallStyles = StyleSheet.create({
  smallCard: {
    flex: 1,
    height: 100,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    backgroundColor: "white",
    borderColor: "#E5E5E5",
    borderWidth: 1,
    borderRadius: 10,
    margin: 5,
  },

  title: {
    fontSize: 22,
    fontWeight: "600",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  resturentTitle: {
    fontSize: 18,
    fontWeight: "400",
    display: "flex",
    color: "#565555",
  },
  price: {
    fontSize: 18,
    fontWeight: "400",
    display: "flex",
    color: "#EA5656",
  },
  foodImageSmall: {
    borderRadius: 10,
    height: 99,
    width: 99,
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: "rgba(81, 77, 77, 0.25)",
    alignSelf: "center",
  },
  rating: {
    alignSelf: "flex-start",
  },
  productInfo: {
    flex: 1,
    padding: 5,
    justifyContent: "space-around",
  },
  shopView: {
    justifyContent: "space-between",
    padding: 10,
    alignItems: "center",
  },
  productSize: {
    fontSize: 20,
    fontWeight: "600",
    color: "#848484",
  },
});

export default GrupoCard;
